module.exports = __webpack_public_path__ + "static/img/PASOS_CIUDADANIA.b08532b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PASOS_CIUDADANIA.jpeg
// module id = 9P0q
// module chunks = 1